import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { FadeIn } from './ui/FadeIn';
export function Incluye() {
  const packs = [{
    icon: '🚗',
    nombre: 'Mecánico Check: El Escudo Anti-Estafas',
    desc: 'Para dueños de autos usados que no quieren que les vean la cara.',
    items: ['Tomo 1: La Auditoría Preventiva', 'Tomo 2: El Diccionario del Chamuyo', 'Tomo 3: Mantenimiento Low-Cost'],
    bonos: ['Bono 1: Checklist de Recepción', 'Bono 2: Guía de Precios de Referencia']
  }, {
    icon: '🏍️',
    nombre: 'Service Pro: Tu Moto en Casa',
    desc: 'Para motociclistas que quieren ahorrar y no depender del taller.',
    items: ['Tomo 1: Setup de Garaje', 'Tomo 2: El Service de los 10k', 'Tomo 3: Sistema Eléctrico y Frenos'],
    bonos: ['Bono 3: Manual de Lubricantes', 'Bono 4: Plan de Mantenimiento Preventivo']
  }];
  return <section id="incluye" className="bg-mc-dark2 py-[72px] px-5" data-id="element-105">
      <div className="max-w-[1100px] mx-auto" data-id="element-106">
        <FadeIn data-id="element-107">
          <SectionHeading centered data-id="element-108">
            Todo lo que recibís dentro del{' '}
            <span className="text-mc-yellow" data-id="element-109">Pack Taller Blindado</span>
          </SectionHeading>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-7 mt-10" data-id="element-110">
          {packs.map((pack, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-111">
              <div className="bg-mc-gray rounded-xl p-8 border-2 border-mc-gray3 relative overflow-hidden h-full" data-id="element-112">
                <div className="absolute top-0 left-0 right-0 h-1 bg-mc-yellow" data-id="element-113" />
                <div className="text-[2.4rem] mb-3" data-id="element-114">{pack.icon}</div>
                <div className="font-display text-[1.2rem] font-black text-mc-yellow uppercase mb-1.5" data-id="element-115">
                  {pack.nombre}
                </div>
                <div className="text-[0.88rem] text-mc-text mb-5" data-id="element-116">
                  {pack.desc}
                </div>
                <ul className="flex flex-col gap-2.5 list-none" data-id="element-117">
                  {pack.items.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-[0.93rem] text-gray-200" data-id="element-118">
                      <span className="text-mc-yellow font-black shrink-0 mt-px" data-id="element-119">
                        ✔
                      </span>
                      {item}
                    </li>)}
                  {pack.bonos.map((bono, i) => <li key={`bono-${i}`} className="flex items-start gap-2.5 text-[0.93rem] text-gray-200" data-id="element-120">
                      <span className="text-mc-yellow font-black shrink-0 mt-px" data-id="element-121">
                        ✔
                      </span>
                      <span data-id="element-122">
                        {bono}{' '}
                        <span className="inline-block bg-mc-yellow/15 text-mc-yellow text-[0.72rem] font-bold py-0.5 px-2 rounded ml-1" data-id="element-123">
                          BONO
                        </span>
                      </span>
                    </li>)}
                </ul>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}